module.exports = __webpack_public_path__ + "img/device_cover_d.ad852a6a.svg";